import '../css/app.scss';
import './script/neto.js';
import './script/popupCalls';

import 'aos/dist/aos.css';
import { addEvent, appHeight } from './script/utils';
import lazyLoad from './script/lazyLoad';
import stickyHeader from './script/stickyHeader';
import advertWrap from './script/advertWrap';
import mobMenu from './script/mobMenu';
import sliders from './script/slider';
import featuredHover from './script/featuredHover';
import video from './script/video';
import line from './script/line';
import imgCoordinates from './script/imgCoordinates';
import dropdown from './script/dropdowns';
import catToggle from './script/catToggle';
import accordian from './script/accordian';
import showHideFilters from './script/showHideFilters';
import anchorOffset from './script/anchorOffset';
import readMore from './script/readmore';
import variations from './script/variations';
import prodHeader from './script/prodHeader';
import cartLine from './script/cartLine';
import specs from './script/specs';
import sections from './script/sections';
import timeline from './script/timeline';
import gallery from './script/gallery';
import toggleMap from './script/toggleMap';
import storeFinder from './script/storefinder';
import crossellForm from './script/crossellForm';

crossellForm.init();
lazyLoad.init();
stickyHeader.init();
advertWrap.init();
mobMenu.init();
sliders.init();
video.init();
line.init();
imgCoordinates.init();
dropdown.init();
catToggle.init();
featuredHover.init();
accordian.init();
showHideFilters.init();
anchorOffset.init();
readMore.init();
variations.init();
prodHeader.init();
cartLine.init();
specs.init();
sections.init();
timeline.init();
gallery.init();
toggleMap.init();
storeFinder.init();
addEvent();
appHeight();
